import { useState } from 'react';
import type { ReactNode } from 'react';
import { loadSidebarState, saveSidebarState, SidebarContext } from './SidebarContext';

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(loadSidebarState);

  const toggle = () => {
    setIsOpen((prev: boolean) => {
      const next = !prev;
      saveSidebarState(next);
      return next;
    });
  };

  const close = () => {
    setIsOpen(false);
    saveSidebarState(false);
  };

  return (
    <SidebarContext.Provider value={{ isOpen, toggle, close }}>{children}</SidebarContext.Provider>
  );
}
